import { ProjectStateAsString } from 'controllers/Project/ProjectStateMachine'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { CSSProperties, useCallback, useEffect, useMemo, useState } from 'react'
import { useAppSelector } from 'store/configureStore'
import { useRequestedProjectState } from './useRequestedProjectState'

const errors = []

export const useQuoteProjectState = () => {
  const {
    canChangeToRequestState,
    Errors: RequestedErrors,
    errorCount: requestedErrorsCount,
  } = useRequestedProjectState()
  const currentProjectStatus = useAppSelector(
    projectSelectors.projectStatusSelector
  )
  const isBuyerView = useAppSelector(
    projectSelectors.ProjectInBuyerViewSelector
  )

  // const dispatch = useAppDispatch()

  const [errorCount, setErrorCount] = useState(requestedErrorsCount)

  const canChangeToQuoteState =
    canChangeToRequestState &&
    currentProjectStatus !== ProjectStateAsString.QUOTED

  /**
   * if the current state is quoted, a salesperson can change to negotiating
   */
  const canChangeToNegotiatingState = useMemo(() => {
    if (currentProjectStatus === ProjectStateAsString.QUOTED && !isBuyerView) {
      return true
    }

    return false
  }, [currentProjectStatus, isBuyerView])

  // const requestProject = useCallback(() => {
  //   dispatch(
  //     saveProjectStatus({
  //       from: currentProjectStatus,
  //       to: ProjectStateAsString.REQUESTED,
  //     })
  //   )
  // }, [currentProjectStatus, dispatch])

  useEffect(() => {
    setErrorCount(requestedErrorsCount)
    // errors.length = 0
    // if (!canChangeToQuoteState) {
    //   errors.push(
    //     <li key="invalid-project-state" style={{ cursor: 'pointer' }} onClick={requestProject}>
    //       <LocalizedTypography component="p" translationKey="project:require-project-first-error-title" variant="body1" color="error">Project is should be requested before quoting</LocalizedTypography>
    //       <LocalizedTypography translationKey="project:require-project-first-error-caption" variant="caption">request the project</LocalizedTypography>
    //     </li>
    //   )
    // }
  }, [canChangeToQuoteState, requestedErrorsCount])

  const Errors = useCallback(() => {
    return (
      <>
        <RequestedErrors />
        {!!errors.length && <ul>{errors}</ul>}
      </>
    )
  }, [RequestedErrors])

  const errorStyle: CSSProperties | undefined =
    !canChangeToQuoteState && !canChangeToNegotiatingState
      ? {
          cursor: 'not-allowed',
        }
      : undefined

  return {
    canChangeToNegotiatingState,
    canChangeToQuoteState,
    Errors,
    errorStyle,
    errorCount,
    currentProjectStatus,
  }
}
